import './styles/special-ribbon.css';
import React from 'react';
import PropTypes from 'prop-types';

import Card from './../Card';
import Ribbon, { RibbonPropTypes } from './';
import { MUSIC_RIBBON_TYPE, RECORDINGS_VIEWED } from '../RibbonGrid/constants';

const getTitle = (title) => {
  const titleContainer = (
    <div className="special-ribbon-title"  dangerouslySetInnerHTML={{ __html: title }}>

    </div>
  );

  return (title)
    ? titleContainer
    : null;
};

const getSibling = (item) => {
  //console.log ("[SpecialRibbon] getSibbling", item);
  const siblingContainer = (
    <div className="special-ribbon-sibling">
      <div className="special-ribbon-sibling-container">
        <Card {...item} type="portrait" focusable={false} />
      </div>
      <div className="arrow-right" />
    </div>
  );

  return (item)
    ? siblingContainer
    : null;
};

const getRibbon = props => {
  const tmp = Object.assign({}, props);
  let classGridMusic = '';
  if (tmp && tmp.type == MUSIC_RIBBON_TYPE) {
    tmp.visibleNumber = 6;
    classGridMusic = 'music-container-ribbon';
    tmp.type = 'square';
    tmp.isMusicRibbon = true;
  }
  const ribbonContainer = (
    <div className="special-ribbon-carousel">
      <Ribbon
        {...tmp}
        title={''}
        carruselTitle={tmp.title}
        className={classGridMusic}
        idsRibbonsUpAndDown = {props.idsRibbonsUpAndDown}
      />
    </div>
  );

  return props ? ribbonContainer : null;
};

const SpecialRibbon = (props) => {
  if(props.items && props.items.length <1 && !props.hasRecordings){
      return null
  }
  const sibling = props.sibling;
  const activateSiblings = false;//se quitan siblings para nueva experiencia
  const classIfRecordings = `${ (props.id === RECORDINGS_VIEWED) ? 'container-recordings' : '' }`;
  const bottomRibbonClass = props.bottomRibbon ? props.bottomRibbon : '';
  if (sibling && activateSiblings) {
    const ribbonClassName = `special-ribbon ${ (props.sibling) ? 'one-to-many ' : '' }`;

    return (
      <div className={`${ribbonClassName}${bottomRibbonClass}`}>
        {getTitle(props.title)}
        {getSibling(props.sibling)}
        {getRibbon(props)}
      </div>
    );
  }
  return (
    <div className={`${classIfRecordings}${bottomRibbonClass}`}>
      {getTitle(props.title)}
      {getRibbon(props)}
    </div>
  );
};

const propTypes = Object.assign({
  title: PropTypes.string,
  sibling: PropTypes.object,
  items: PropTypes.array
}, RibbonPropTypes);

SpecialRibbon.propTypes = propTypes;

SpecialRibbon.defaultProps = {
  title: null,
  sibling: null,
  items: null
};

export default SpecialRibbon;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/SpecialRibbon.jsx